<template>
  <div class="app" v-if="loaded">
    <div class="hamburger" v-on:click="openMenu()">…</div>
    <div :class="{menu:true,open:menuOpen}">
      <div class="cross" v-on:click="closeMenu()">
        <svg version="1.1" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" xml:space="preserve">
        <line fill="#FFFFFF" stroke="#FFFFFF" stroke-width="2" stroke-miterlimit="10" x1="0.5" y1="0.5" x2="19.4" y2="19.4"/>
        <line fill="#FFFFFF" stroke="#FFFFFF" stroke-width="2" stroke-miterlimit="10" x1="19.4" y1="0.5" x2="0.5" y2="19.4"/>
        </svg>
      </div>
      <div :class="{tag:true,'new-category':tag.newCategory}" v-for="tag in tags">
        <router-link v-on:click.native="scrollToTop()" v-if="tag.projects" :to="{name:'tag',params:{tag:tag.name}}">{{tag.title}}&nbsp;<sup>{{tag.projects.length}}</sup> </router-link>
      </div>
      <router-link tag="a" class="tag" to="/contact">About / Contact</router-link>

    </div>
    <router-view  v-on:click@native="closeMenu()" :about="about" :projects="projects" :tags="tags"></router-view>
  </div>
</template>
<script>
  export default {
    name: 'app',
    data() {
      return {
        projects: {},
        about: '',
        tags: {},
        loaded: false,
        menuOpen: false
      }
    },
    mounted: function() {
      // const canVar = window.CSS.supports('--fake-var', 0);
      // if(!canVar) {
      //   alert('It looks like you are using an older browser. I am working on getting this site to work on older browsers, but for the time being it doesn\'t. If you don\'t have a new browser available please contact me directly on joelgalvez@gmail.com' );
      // }
      fetch('/projects/').then(response => {
        return response.json();
      }).then(rep => {
        this.projects = rep.projects;
        this.about = rep.about;
        this.tags = rep.tags;
        this.loaded = true;
      }).catch(err => {
        console.log("Error while fetching data.")
      });      
    },
    watch: {
      '$route' (to, from) {
        this.closeMenu();
      }
    },
    methods: {
      scrollToTop() {
        window.scrollTo(0, 0);
      },
      openMenu() {
        this.menuOpen = true;
      },
      closeMenu() {
        this.menuOpen = false;
      }
    }
  }
</script>
<style lang="scss">
  @import 'reset';
  @import 'src/assets/inter';

  * {
    box-sizing: border-box;
  }

  html {
    background: black;
    color: white;
    font-family: Inter,sans-serif;
    font-weight: 400;
    overflow-y:scroll;
    overflow-x:hidden;
    font-size: 100%;
  }
  
  body {
    font-size: 1.4rem;
    line-height: 1.2;
  }
  a {
    color: inherit;
    text-decoration: none;
    opacity: 0.7;
    transition:text-shadow 0.2s ease;
    &.block {
      opacity: 1;
    }
    &:hover {    
      opacity: 1;
      text-shadow:0 0 1.5rem white,0 0 .5rem white;
    }
  }
  .menu {
    a.router-link-active {
      opacity: 1;
      text-shadow:0 0 1.5rem white,0 0 .5rem white;
    }
  }
  sup {
    vertical-align: super;
    font-size: smaller;
    margin-right: 1rem;
  }
  .app {
    margin:1rem;
    .hamburger {
      position: fixed;
      z-index: 15;
      top:0;
      right: 0rem;
      padding:1rem;
      // padding-top:0;
      // font-size: 2rem;
      cursor: pointer;
    }
    .menu {
      display: none;
      &.open {
        display: block;
      }
      overflow-y:auto;
      position: fixed;
      right:0;
      top:0;
      padding:1rem;
      height: 100vh;
      width: 19rem;
      background-color: #000;
      z-index: 20;
      >.tag:last-child {
        padding-bottom: 5rem;
      }

      .cross {
        position: absolute;
        right:0;
        top:0;
        text-align: right;
        cursor: pointer;
        padding:1rem;
        // padding-top:0.5rem;
        svg {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
      .tag {
        &.new-category {
          margin-top: 2rem;
        }
        a {
          // white-space: nowrap;
        }
      }
      margin-bottom: 0.5rem;
    }
  }
</style>
